import React from 'react';
import { twMerge } from 'tailwind-merge';

interface IImageUploadButtonProps {
  icon: JSX.Element;
  onClick: () => void;
  styles?: string;
  dataTestId?: string;
}

const ImageUploadButton = ({
  icon,
  onClick,
  styles,
  dataTestId,
}: IImageUploadButtonProps) => {
  const containerClassName = twMerge(
    'absolute',
    'top-2',
    'right-2',
    'bg-white',
    'p-2',
    'z-10',
    'text-kira-blue-300',
    '!prose-body-sm-med',
    'transition',
    'rounded',
    'hover:bg-kira-red-800',
    'hover:text-white',
    styles
  );

  return (
    <button
      type="button"
      className={containerClassName}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <div id="iconContainer" className="h-4 w-4">
        {icon}
      </div>
    </button>
  );
};

export default ImageUploadButton;
